import React from "react";
import { Table } from "reactstrap";
// icone
import { FaRankingStar } from "react-icons/fa6";

export default function UserPoints(props) {
  const { nameGuest, pointsGuest, guestPointsCardBackground, guestPointsCardColor } = props;
  return (
    <>
      <div className="div-userPoints" style={{ background: guestPointsCardBackground }}>
        <a className="icon-userPoint">
          <FaRankingStar color="gold" />
        </a>

        <a className="a-user-name" style={{ color: guestPointsCardColor }}>{nameGuest ? nameGuest : "-"}</a>

        <a>
          {pointsGuest ? (
            <div className="div-user-points">
              <a style={{ color: guestPointsCardColor }}>{pointsGuest}</a>
              <a style={{ color: guestPointsCardColor }}>Pontos</a>
            </div>
          ) : (
            <div style={{ color: guestPointsCardColor }}>-</div>
          )}
        </a>
      </div>
    </>
  );
}
